/* eslint-disable no-loss-of-precision */
import EyeshadowYesDefaultTall from '../Eyebrows/EyeshadowYesDefaultTall'
import EyeshadowYesLs from '../Eyebrows/EyeshadowYesLs'
import EyeshadowYesRainbow from '../Eyebrows/EyeshadowYesRainbow'
import EyeshadowYesRainbowSkinny from '../Eyebrows/EyeshadowYesRainbowSkinny'
import EyeshadowYesComment from '../Eyebrows/EyeshadowYesComment'
import EyeshadowYesRectangleSkinny from '../Eyebrows/EyeshadowYesRectangleSkinny'
import EyeshadowYesCurveLarge from '../Eyebrows/EyeshadowYesCurveLarge'
import EyeshadowYesRectangles from '../Eyebrows/EyeshadowYesRectangles'
import EyeshadowYesCurveMed from '../Eyebrows/EyeshadowYesCurveMed'
import EyeshadowYesSmallRound from '../Eyebrows/EyeshadowYesSmallRound'
import EyeshadowYesCurveSmall from '../Eyebrows/EyeshadowYesCurveSmall'
import EyeshadowYesTriangle from '../Eyebrows/EyeshadowYesTriangle'
import EyeshadowYesDefault from '../Eyebrows/EyeshadowYesDefault'
import EyeshadowYesDefaultSmall from '../Eyebrows/EyeshadowYesDefaultSmall'

const data = [
  {
    id: 'EyeshadowYesDefaultTall',
    svg: EyeshadowYesDefaultTall,
    positioning: {
      pointNarrow: {
        y: 90,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 90.44276428222656,
        scaleX: 0.95,
      },
      pointWide: {
        y: 88.07504272460938,
        scaleX: 1,
      },
      roundNarrow: {
        y: 91.83111572265625,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 91.69877624511719,
        scaleX: 0.9,
      },
      roundWide: {
        y: 90,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 90.33746337890625,
        scaleX: 0.9,
      },
      squareWide: {
        y: 90.13652038574219,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesLs',
    svg: EyeshadowYesLs,
    positioning: {
      pointNarrow: {
        y: 90.13919067382812,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 90.34588623046875,
        scaleX: 0.9,
      },
      pointWide: {
        y: 89.13893127441406,
        scaleX: 1,
      },
      roundNarrow: {
        y: 93.35224914550781,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 92.0322265625,
        scaleX: 0.85,
      },
      roundWide: {
        y: 91.16192626953125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 90.44712829589844,
        scaleX: 0.95,
      },
      squareWide: {
        y: 90,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesRainbow',
    svg: EyeshadowYesRainbow,
    positioning: {
      pointNarrow: {
        y: 90,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 88.61631774902344,
        scaleX: 0.9,
      },
      pointWide: {
        y: 88.8570556640625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 93.04385375976562,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 92.53396606445312,
        scaleX: 0.85,
      },
      roundWide: {
        y: 91.71917724609375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 90,
        scaleX: 0.9,
      },
      squareWide: {
        y: 90.76434326171875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesRainbowSkinny',
    svg: EyeshadowYesRainbowSkinny,
    positioning: {
      pointNarrow: {
        y: 93.66157531738281,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 90.64810180664062,
        scaleX: 0.8,
      },
      pointWide: {
        y: 90.00001525878906,
        scaleX: 1,
      },
      roundNarrow: {
        y: 94.08502197265625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 94.84490966796875,
        scaleX: 0.9,
      },
      roundWide: {
        y: 93.33477783203125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 95.57554626464844,
        scaleX: 1,
      },
      squareMedium: {
        y: 92.28105163574219,
        scaleX: 0.95,
      },
      squareWide: {
        y: 93.74118041992188,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesComment',
    svg: EyeshadowYesComment,
    positioning: {
      pointNarrow: {
        y: 90,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 89.4263916015625,
        scaleX: 0.85,
      },
      pointWide: {
        y: 89.34335327148438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 91.17369079589844,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 90,
        scaleX: 0.9,
      },
      roundWide: {
        y: 90.63674926757812,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90.14039611816406,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 86.98844909667969,
        scaleX: 0.9,
      },
      squareWide: {
        y: 90.57011413574219,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesRectangleSkinny',
    svg: EyeshadowYesRectangleSkinny,
    positioning: {
      pointNarrow: {
        y: 90.5872802734375,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 91.45567321777344,
        scaleX: 0.9,
      },
      pointWide: {
        y: 90.01893615722656,
        scaleX: 1,
      },
      roundNarrow: {
        y: 94.07417297363281,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 92.81477355957031,
        scaleX: 1,
      },
      roundWide: {
        y: 91.49571228027344,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.64141845703125,
        scaleX: 0.95,
      },
      squareWide: {
        y: 92.12319946289062,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesCurveLarge',
    svg: EyeshadowYesCurveLarge,
    positioning: {
      pointNarrow: {
        y: 90.28388977050781,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 90,
        scaleX: 0.95,
      },
      pointWide: {
        y: 91.11128234863281,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 94.16891479492188,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 94.18569946289062,
        scaleX: 1,
      },
      roundWide: {
        y: 92.11079406738281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 92.00938415527344,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 90,
        scaleX: 1,
      },
      squareWide: {
        y: 92.11637878417969,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesRectangles',
    svg: EyeshadowYesRectangles,
    positioning: {
      pointNarrow: {
        y: 90,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 90,
        scaleX: 0.95,
      },
      pointWide: {
        y: 88.39993286132812,
        scaleX: 1,
      },
      roundNarrow: {
        y: 92.70112609863281,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 91.28953552246094,
        scaleX: 1,
      },
      roundWide: {
        y: 91.32383728027344,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 90,
        scaleX: 1,
      },
      squareWide: {
        y: 90,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesCurveMed',
    svg: EyeshadowYesCurveMed,
    positioning: {
      pointNarrow: {
        y: 90.96565246582031,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 91.92477416992188,
        scaleX: 0.9,
      },
      pointWide: {
        y: 90,
        scaleX: 1,
      },
      roundNarrow: {
        y: 94.560791015625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 93.0533447265625,
        scaleX: 1,
      },
      roundWide: {
        y: 92.25439453125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 92.19004821777344,
        scaleX: 0.95,
      },
      squareWide: {
        y: 91.61691284179688,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesSmallRound',
    svg: EyeshadowYesSmallRound,
    positioning: {
      pointNarrow: {
        y: 91.91691589355469,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 92.60092163085938,
        scaleX: 0.95,
      },
      pointWide: {
        y: 90,
        scaleX: 1,
      },
      roundNarrow: {
        y: 95.77177429199219,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 94.76852416992188,
        scaleX: 1,
      },
      roundWide: {
        y: 92.56857299804688,
        scaleX: 1,
      },
      squareNarrow: {
        y: 92.27737426757812,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 91.31564331054688,
        scaleX: 0.95,
      },
      squareWide: {
        y: 92.34239196777344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'EyeshadowYesCurveSmall',
    svg: EyeshadowYesCurveSmall,
    positioning: {
      pointNarrow: {
        y: 90.66500854492188,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 91.86892700195312,
        scaleX: 0.95,
      },
      pointWide: {
        y: 91.58306884765625,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 94.30760192871094,
        scaleX: 0.9,
      },
      roundMedium: {
        y: 92.79067993164062,
        scaleX: 1,
      },
      roundWide: {
        y: 91.715087890625,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 92.17330932617188,
        scaleX: 0.95,
      },
      squareWide: {
        y: 90,
        scaleX: 1.05,
      },
    },
  },
  {
    id: 'EyeshadowYesTriangle',
    svg: EyeshadowYesTriangle,
    positioning: {
      pointNarrow: {
        y: 90,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 91.0167236328125,
        scaleX: 0.85,
      },
      pointWide: {
        y: 90.29420471191406,
        scaleX: 1,
      },
      roundNarrow: {
        y: 92.40518188476562,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 93.11349487304688,
        scaleX: 0.95,
      },
      roundWide: {
        y: 91.82316589355469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 89.97465515136719,
        scaleX: 0.95,
      },
      squareWide: {
        y: 89.768798828125,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'EyeshadowYesDefault',
    svg: EyeshadowYesDefault,
    positioning: {
      pointNarrow: {
        y: 90.95721435546875,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 93.43446350097656,
        scaleX: 0.85,
      },
      pointWide: {
        y: 90.68572998046875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 95.00184631347656,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 93.85032653808594,
        scaleX: 0.85,
      },
      roundWide: {
        y: 92.60552978515625,
        scaleX: 0.9,
      },
      squareNarrow: {
        y: 92.37835693359375,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 91.08221435546875,
        scaleX: 0.9,
      },
      squareWide: {
        y: 92.48886108398438,
        scaleX: 0.9,
      },
    },
  },
  {
    id: 'EyeshadowYesDefaultSmall',
    svg: EyeshadowYesDefaultSmall,
    positioning: {
      pointNarrow: {
        y: 91.15266418457031,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 94.39384460449219,
        scaleX: 0.95,
      },
      pointWide: {
        y: 90.43362426757812,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 94.48197937011719,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 92.91145324707031,
        scaleX: 1,
      },
      roundWide: {
        y: 92.43577575683594,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 92.15225219726562,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 90,
        scaleX: 1,
      },
      squareWide: {
        y: 91.92758178710938,
        scaleX: 1.05,
      },
    },
  },
]

export default data
